import { Fragment } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import { useTopbarCompacta } from './topbarCompacta';

export interface BreadcrumbItem {
    id: string;
    label: ReactNode;
}

export interface BreadcrumbProps {
    items?: BreadcrumbItem[];
    onNavigate?: (id: string) => void;
    /** Nome da trilha para leitores de tela. */
    ariaLabel?: string;
    style?: CSSProperties;
}

export function Breadcrumb({ items = [], onNavigate, ariaLabel = 'Trilha de navegação', style }: BreadcrumbProps) {
    /* Na topbar compacta fica só a página atual, truncando. Os níveis de cima
       não cabiam e saíam cortados pela metade; eles continuam a um toque, no
       menu lateral. */
    const compacta = useTopbarCompacta();
    const visiveis = compacta ? items.slice(-1) : items;
    return (
        <nav
            aria-label={ariaLabel}
            style={{ display: 'flex', alignItems: 'center', gap: 6, fontFamily: 'var(--font-ui)', fontSize: 13, minWidth: 0, overflow: 'hidden', ...style }}
        >
            {visiveis.map((it, i) => {
                const ultimo = i === visiveis.length - 1;
                return (
                    <Fragment key={it.id}>
                        {i > 0 && <span aria-hidden="true" style={{ color: 'var(--neutral-400)' }}>/</span>}
                        <button
                            type="button" disabled={ultimo}
                            aria-current={ultimo ? 'page' : undefined}
                            onClick={() => onNavigate?.(it.id)}
                            style={{
                                border: 0, background: 'transparent', padding: '2px 0', cursor: ultimo ? 'default' : 'pointer',
                                color: ultimo ? 'var(--text-primary)' : 'var(--text-secondary)', fontWeight: ultimo ? 600 : 400,
                                fontFamily: 'inherit', fontSize: 'inherit', whiteSpace: 'nowrap',
                                /* O crumb atual trunca; os anteriores cedem primeiro por serem
                                   mais curtos e recuperáveis por clique. */
                                minWidth: ultimo ? 0 : undefined, flex: ultimo ? '0 1 auto' : '0 0 auto',
                                overflow: 'hidden', textOverflow: 'ellipsis',
                            }}
                        >
                            {it.label}
                        </button>
                    </Fragment>
                );
            })}
        </nav>
    );
}
